'use strict';

class RuntimeConfig {
  #appId;
  #runtimeConfig;
  constructor({
    runtimeConfigKeys,
    appId
  }) {
    this.#appId = appId;
    this.#runtimeConfig = this.#getRuntimeConfigWithSafeAccessToWindow(runtimeConfigKeys);
  }
  #getInitialConfigValues = (keys) => {
    return keys.reduce(
      (acc, cur) => ({ ...acc, [cur]: "" }),
      {}
    );
  };
  /**
   * MF appId를 받아 window에서 runtime config 객체를 찾아 가져오는 함수입니다.
   * MF App에서만 사용됩니다.
   */
  #getRuntimeConfigWithSafeAccessToWindow = (runtimeConfigKeys) => {
    if (typeof window === "undefined") {
      return this.#getInitialConfigValues(runtimeConfigKeys);
    }
    const runtimeConfigs = window.__FLEX__?.["runtime-configs"];
    if (runtimeConfigs === void 0) {
      return this.#getInitialConfigValues(runtimeConfigKeys);
    }
    return {
      ...this.#getInitialConfigValues(runtimeConfigKeys),
      ...runtimeConfigs[this.#appId]
    };
  };
  get values() {
    return this.#runtimeConfig;
  }
}

exports.RuntimeConfig = RuntimeConfig;
//# sourceMappingURL=RuntimeConfig.cjs.map
